import React, { useEffect } from "react";
import { TextField } from "../../../ui/FormElement";

import { useFormikContext } from "formik";

const OnetimeDiscountName = (props) => {
  const { isDisabled, ...rest } = props;

  const {
    values: { onetime_discount_enable },
    setFieldValue,
  } = useFormikContext();

  return (
    <>
      <TextField
        disabled={!onetime_discount_enable || isDisabled}
        name="onetime_discount_name"
        {...rest}
      />
    </>
  );
};

export default OnetimeDiscountName;
